module.exports = __webpack_public_path__ + "img/thunderkick.c938a31a.svg";